import { render, staticRenderFns } from "./release.vue?vue&type=template&id=c8176d34&"
import script from "./release.vue?vue&type=script&lang=js&"
export * from "./release.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports